export var LogType;
(function (LogType) {
    LogType["ERROR"] = "ERROR";
    LogType["WARN"] = "WARN";
    LogType["INFO"] = "INFO";
    LogType["DEBUG"] = "DEBUG";
    LogType["SILLY"] = "SILLY";
})(LogType || (LogType = {}));
function toError(value) {
    if (value instanceof Error) {
        return value;
    }
    if (typeof value === 'string') {
        return new Error(value);
    }
    return new Error(String(value));
}
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof Error);
}
export function createLoggerAdapter(winstonLogger) {
    return {
        error(message, errorOrContext, context) {
            if (errorOrContext === undefined && context === undefined) {
                winstonLogger.error(message);
                return;
            }
            if (context !== undefined) {
                const errorObj = toError(errorOrContext);
                winstonLogger.error(message, { error: errorObj, ...context });
                return;
            }
            if (isPlainObject(errorOrContext)) {
                winstonLogger.error(message, errorOrContext);
                return;
            }
            const errorObj = toError(errorOrContext);
            winstonLogger.error(message, { error: errorObj });
        },
        warn(message, meta) {
            winstonLogger.warn(message, meta);
        },
        info(message, meta) {
            winstonLogger.info(message, meta);
        },
        debug(message, meta) {
            winstonLogger.debug(message, meta);
        },
        silly(message, meta) {
            if (winstonLogger.silly) {
                winstonLogger.silly(message, meta);
            }
            else {
                winstonLogger.debug(message, meta);
            }
        },
    };
}
const defaultLogger = {
    error(message, errorOrContext, context) {
        if (context !== undefined) {
            const errorObj = toError(errorOrContext);
            console.error(message, { error: errorObj, ...context });
            return;
        }
        if (errorOrContext !== undefined) {
            if (isPlainObject(errorOrContext)) {
                console.error(message, errorOrContext);
            }
            else {
                console.error(message, { error: toError(errorOrContext) });
            }
            return;
        }
        console.error(message);
    },
    warn(message, meta) {
        console.warn(message, meta);
    },
    info(message, meta) {
        console.info(message, meta);
    },
    debug(message, meta) {
        console.debug(message, meta);
    },
    silly(message, meta) {
        console.log(message, meta);
    },
};
let _logger = defaultLogger;
export const init = (logger) => {
    _logger = logger;
};
export const getLogger = () => _logger;
//# sourceMappingURL=logger.js.map